import { useAsyncOperationState } from '../../../dorian-shared/hooks/useAsyncOperationState';
import { api } from '../../api';
import { createFormDataFromOfferFormValues, OfferFormValues } from './components/OfferForm/offerFormLogic';

export function useCreateOffer() {
  const [, {
    isLoading, setToLoading, setToError, setToSuccess,
  }] = useAsyncOperationState();

  const createOffer = (values: OfferFormValues) => {
    setToLoading();
    return api.post('/v1/offers', createFormDataFromOfferFormValues(values), {
      headers: { 'content-type': 'multipart/form-data' },
    })
      .then((response) => {
        setToSuccess();
        return response.data.offer;
      })
      .catch((error) => {
        setToError();
        throw new Error(error.response?.data?.error ?? 'The offer could not be saved. Check your connection and try again.');
      });
  };
  return { isLoading, createOffer };
}
